module.exports = __webpack_public_path__ + "static/img/swiper_title.625ded3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mo/swiper_title.png
// module id = PlCg
// module chunks = 0